module.exports = __webpack_public_path__ + "static/media/sp.caa6452f.svg";